// extracted by mini-css-extract-plugin
module.exports = {"xlabel":"ComboDistributionChart_xlabel__74IE8","ylabel":"ComboDistributionChart_ylabel__KmO_n"};